/* assets/assistant-colour-update.js */
(function () {
  var node = document.getElementById('AurexAssistantFaqs');
  if (!node) return;

  var faqs = [];
  try {
    faqs = JSON.parse(node.textContent) || [];
  } catch (error) {
    faqs = [];
  }

  function upsertFaq(faq, matcher) {
    var index = faqs.findIndex(function (item) {
      var text = ((item.question || '') + ' ' + (item.keywords || '')).toLowerCase();
      return matcher(text);
    });
    if (index >= 0) {
      faqs[index] = Object.assign({}, faqs[index], faq);
    } else {
      faqs.push(faq);
    }
  }

  upsertFaq({
    question: 'What frame colours are available?',
    keywords: 'frame, colour, color, colours, colors, black, white, chrome, brushed gold, gold',
    answer: 'Wardrobe frame colours currently available are Black, Brushed Gold, White and Chrome. You can preview every finish in each frame colour on the Wardrobe Doors page.',
    linkLabel: 'View wardrobe options',
    linkUrl: '/pages/wardrobe-doors'
  }, function (text) {
    return text.indexOf('frame') !== -1 && (text.indexOf('colour') !== -1 || text.indexOf('color') !== -1);
  });

  var contactLink = '/pages/contact';
  var confirmCaveat = ' Final suitability, pricing and availability must be confirmed by Aurex before quoting or ordering.';

  [
    {
      question: 'Can you confirm shower hardware availability?',
      keywords: 'stock, stocked, availability, available, in stock, have it, order hardware',
      answer: 'Aurex does not share private trade-supply details publicly. I can help with suitable shower screen options, and Aurex will confirm availability for your quote.',
      linkLabel: 'Ask Aurex to confirm',
      linkUrl: contactLink
    },
    {
      question: 'What shower hardware finishes can I ask about?',
      keywords: 'hardware finish, hardware finishes, colours, colors, chrome, matt black, matte black, pearl satin, brushed brass, brushed gold, matt white, matte white, gunmetal, brushed nickel',
      answer: 'Aurex can discuss shower hardware finishes such as chrome, matt black, satin-style finishes, brushed gold/brass, matt white, gunmetal and brushed nickel.' + confirmCaveat,
      linkLabel: 'Confirm hardware finish',
      linkUrl: contactLink
    },
    {
      question: 'What frameless shower hardware can Aurex quote?',
      keywords: 'frameless hardware, hinge, hinges, bracket, brackets, knob, knobs, handle, handles, brace, stabiliser, stabilizer, support arm, u channel, water bar, seal, seals',
      answer: 'Aurex can help with frameless shower hardware such as hinges, wall brackets, fixed brackets, round knobs, handles, door stops, support options, u-channels, shower seals and water bars.' + confirmCaveat,
      linkLabel: 'Ask about hardware',
      linkUrl: contactLink
    },
    {
      question: 'Is brushed gold shower hardware available?',
      keywords: 'brushed gold, gold hardware, brushed brass, gold hinge, gold hinges, gold knob, gold handle, gold bracket',
      answer: 'Brushed gold/brass-style shower hardware may be available for suitable shower screens. Aurex should confirm the exact hinge, bracket, handle or knob compatibility for the opening before quoting or ordering.',
      linkLabel: 'Confirm brushed gold',
      linkUrl: contactLink
    },
    {
      question: 'Can Aurex quote sliding shower screens?',
      keywords: 'sliding shower, slider, sliding screen, barn door, rail, roller, sliding hardware',
      answer: 'Aurex can discuss sliding shower screen layouts, rail and roller hardware, and finish options for suitable openings.' + confirmCaveat,
      linkLabel: 'Ask about sliding screens',
      linkUrl: contactLink
    },
    {
      question: 'What shower glass thicknesses can be used?',
      keywords: 'glass thickness, 6mm, 8mm, 10mm, 12mm, toughened glass, safety glass, as nzs 2208, grade a',
      answer: 'Shower screens may use 6 mm, 8 mm, 10 mm or 12 mm toughened safety glass depending on the design, opening, hardware and installation requirements. Aurex will confirm the right glass thickness for the quote.',
      linkLabel: 'Confirm glass type',
      linkUrl: contactLink
    },
    {
      question: 'Can Aurex quote bath panels?',
      keywords: 'bath screen, bath screens, bath panel, bath panels, bathware, over bath',
      answer: 'Yes. Aurex can quote bath panels and over-bath glass options after checking the bath layout, wall position, glass size and preferred hardware finish.' + confirmCaveat,
      linkLabel: 'Request bath panel quote',
      linkUrl: contactLink
    },
    {
      question: 'Can Aurex quote semi-frameless or framed shower screens?',
      keywords: 'semi frameless, semi-frameless, framed, fully framed, pivot door, return panel, inline panel',
      answer: 'Yes. Aurex can discuss semi-frameless, framed, pivot-door, return-panel and inline shower screen options. The best fit depends on the opening, panel layout and preferred hardware finish.' + confirmCaveat,
      linkLabel: 'Discuss screen style',
      linkUrl: contactLink
    }
  ].forEach(function (faq) {
    upsertFaq(faq, function (text) {
      return text === (faq.question + ' ' + faq.keywords).toLowerCase();
    });
  });

  node.textContent = JSON.stringify(faqs);

  var quickActions = document.getElementById('AssistantQuickActions');
  if (quickActions && !quickActions.querySelector('[data-shower-hardware-question]')) {
    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-assistant-question', 'What shower hardware finishes can I ask about?');
    button.setAttribute('data-shower-hardware-question', '');
    button.textContent = 'Hardware options';
    quickActions.insertBefore(button, quickActions.querySelector('[data-assistant-lead]'));
  }
})();

(function(){
  var forms=document.querySelectorAll('[data-aurex-protected-form]');
  forms.forEach(function(form){
    var openedAt=Date.now();
    var humanInteraction=false;
    var honeypot=form.querySelector('[data-aurex-honeypot]');
    var warning=form.querySelector('[data-aurex-form-warning]');
    var submitButton=form.querySelector('[type="submit"]');
    ['pointerdown','keydown','input','change'].forEach(function(eventName){
      form.addEventListener(eventName,function(){humanInteraction=true;},{once:true});
    });
    form.addEventListener('submit',function(event){
      var message=form.querySelector('textarea[name="contact[body]"]');
      var tooFast=Date.now()-openedAt<3500;
      if(honeypot&&honeypot.value.trim()){
        event.preventDefault();
        form.reset();
        if(warning){
          warning.textContent='Thanks. Your request has been received.';
          warning.hidden=false;
        }
        return;
      }
      if(tooFast||!humanInteraction){
        event.preventDefault();
        if(warning){
          warning.textContent='Please wait a moment, then send the form again.';
          warning.hidden=false;
        }
        return;
      }
      if(message&&message.value.trim().length<12){
        event.preventDefault();
        if(warning){
          warning.textContent='Please add a few more details about the job.';
          warning.hidden=false;
        }
        message.focus();
        return;
      }
      if(submitButton){
        submitButton.disabled=true;
        submitButton.textContent='Sending...';
      }
    });
  });
})();

/* assets/aurex-audit-fixes.js */
(function () {
  function parseVariants() {
    var node = document.getElementById('AurexVariants');
    if (!node) return [];
    try { return JSON.parse(node.textContent) || []; } catch (error) { return []; }
  }
  function rebuildFrameColours() {
    var select = document.getElementById('FrameColour');
    if (!select) return;
    var selectedColour = select.value;
    var available = parseVariants().reduce(function (colours, variant) {
      if (variant.option2 && colours.indexOf(variant.option2) === -1) colours.push(variant.option2);
      return colours;
    }, []);
    var preferredOrder = ['White', 'Black', 'Chrome', 'Brushed Gold', 'Mat Natural', 'Cream'];
    var colours = preferredOrder.filter(function (colour) { return available.indexOf(colour) !== -1; });
    if (!colours.length) return;
    if (colours.indexOf(selectedColour) === -1) selectedColour = colours[0];
    select.replaceChildren();
    colours.forEach(function (colour) { select.add(new Option(colour, colour, colour === selectedColour, colour === selectedColour)); });
  }
  function hardenAssistantForm() {
    var product = document.getElementById('AssistantLeadProduct');
    var suburb = document.getElementById('AssistantLeadSuburb');
    var details = document.getElementById('AssistantLeadDetails');
    var consent = document.querySelector('#AurexAssistantLeadForm .assistant-consent input');
    if (product) product.name = 'contact[Project type]';
    if (suburb) suburb.name = 'contact[Suburb]';
    if (details) details.name = 'contact[Project details]';
    if (consent) { consent.name = 'contact[Consent]'; consent.value = 'Yes'; }
  }
  function correctPageLinks() {
    document.querySelectorAll('a[href="/#shower-screens"], a[href="#shower-screens"]').forEach(function (link) { link.href = '/pages/shower-screens'; });
    document.querySelectorAll('.choice:not([type])').forEach(function (button) { button.type = 'button'; });
  }
  function init() { rebuildFrameColours(); hardenAssistantForm(); correctPageLinks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* assets/aurex-theme.js */
(function () {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const menu = $("#mobile-menu");
  const openMenu = $("#menu-toggle");
  const closeMenu = $("#mobile-close");
  const setMenu = (isOpen) => {
    if (!menu) return;
    menu.classList.toggle("open", isOpen);
    menu.setAttribute("aria-hidden", String(!isOpen));
    document.body.classList.toggle("menu-open", isOpen);
  };
  openMenu?.addEventListener("click", () => setMenu(true));
  closeMenu?.addEventListener("click", () => setMenu(false));
  $$("#mobile-menu a").forEach((link) => link.addEventListener("click", () => setMenu(false)));

  const measureDialog = $("#MeasureDialog");
  $("[data-measure-open]")?.addEventListener("click", () => {
    const guideImage = measureDialog?.querySelector("[data-measure-dialog-image]");
    if (guideImage && !guideImage.getAttribute("src")) {
      guideImage.src = guideImage.dataset.src;
      guideImage.srcset = guideImage.dataset.srcset || "";
    }
    measureDialog?.showModal();
  });
  $("[data-measure-close]")?.addEventListener("click", () => measureDialog?.close());
  measureDialog?.addEventListener("click", (event) => {
    if (event.target === measureDialog) measureDialog.close();
  });

  const prices = {
    "1200": { Gyprock: 367.84, Mirror: 471.02, "White Glass": 611.16, "Vinyl Back": 407.88, "Semi Frameless": 734.36, "VJ Primed": 651.20 },
    "1500": { Gyprock: 417.12, Mirror: 534.16, "White Glass": 771.32, "Vinyl Back": 489.50, "Semi Frameless": 825.22, "VJ Primed": 712.80 },
    "1800": { Gyprock: 440.22, Mirror: 581.90, "White Glass": 792.88, "Vinyl Back": 514.14, "Semi Frameless": 864.93, "VJ Primed": 774.40 },
    "2100": { Gyprock: 477.18, Mirror: 638.88, "White Glass": 899.09, "Vinyl Back": 551.10, "Semi Frameless": 940.67, "VJ Primed": 836.00 },
    "2400": { Gyprock: 498.74, Mirror: 692.78, "White Glass": 919.88, "Vinyl Back": 574.20, "Semi Frameless": 1017.89, "VJ Primed": 867.90 },
    "2700": { Gyprock: 611.16, Mirror: 817.41, "White Glass": 1081.74, "Vinyl Back": 722.04, "Semi Frameless": 1248.06, "VJ Primed": 1150.05 },
    "3000": { Gyprock: 654.28, Mirror: 887.21, "White Glass": 1271.82, "Vinyl Back": 768.24, "Semi Frameless": 1323.80, "VJ Primed": 1164.90 },
    "3300": { Gyprock: 678.92, Mirror: 937.70, "White Glass": 1259.94, "Vinyl Back": 789.80, "Semi Frameless": 1444.08, "VJ Primed": 1179.75 },
    "3600": { Gyprock: 700.48, Mirror: 976.31, "White Glass": 1311.92, "Vinyl Back": 812.90, "Semi Frameless": 1476.75, "VJ Primed": 1194.60 }
  };
  const config = { width: "2100", finish: "Mirror", slimline: false };
  const priceOutput = $("#config-price");
  const summaryOutput = $("#config-summary");
  const preview = $("#door-preview");
  const productLink = $("#config-product-link");
  const productImages = preview ? {
    Gyprock: preview.dataset.gyprock,
    Mirror: preview.dataset.mirror,
    "White Glass": preview.dataset.whiteGlass,
    "Vinyl Back": preview.dataset.vinylBack,
    "Semi Frameless": preview.dataset.semiFrameless,
    "VJ Primed": preview.dataset.vj
  } : {};
  const productHandles = {
    Gyprock: "gyprock-vinyl-sliding-wardrobe-doors",
    Mirror: "mirror-sliding-wardrobe-doors",
    "White Glass": "super-white-glass-sliding-wardrobe-doors",
    "Vinyl Back": "vinyl-back-sliding-wardrobe-doors",
    "Semi Frameless": "semi-frameless-sliding-wardrobe-doors",
    "VJ Primed": "vj-primed-sliding-wardrobe-doors"
  };

  function updateConfigurator() {
    if (!priceOutput) return;
    let price = prices[config.width][config.finish];
    if (config.slimline) price = (price - 66) * 1.1 + 66;
    priceOutput.textContent = price.toLocaleString("en-AU", { style: "currency", currency: "AUD" });
    summaryOutput.textContent = `2100mm high x ${config.width}mm wide · ${config.finish} · ${config.slimline ? "83mm slimline triple track" : "83mm standard double track"}`;
    if (productLink && productLink.getAttribute("href") !== "#quote") {
      const params = new URLSearchParams({
        width: config.width,
        track: config.slimline ? "slimline" : "standard"
      });
      productLink.href = `/products/${productHandles[config.finish]}?${params.toString()}`;
    }
    if (preview) {
      preview.setAttribute("aria-label", `${config.finish} sliding wardrobe doors`);
    }
  }

  $$("[data-config-group]").forEach((group) => {
    $$(".choice", group).forEach((button) => button.addEventListener("click", () => {
      $$(".choice", group).forEach((item) => item.classList.remove("active"));
      button.classList.add("active");
      config[group.dataset.configGroup] = button.dataset.value;
      updateConfigurator();
    }));
  });
  $("#slimline")?.addEventListener("change", (event) => {
    config.slimline = event.target.checked;
    updateConfigurator();
  });
  updateConfigurator();

  const builderForm = $("#AurexProductForm");
  if (builderForm) {
    const variantsNode = $("#AurexVariants");
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const widths = [1200, 1500, 1800, 2100, 2400, 2700, 3000, 3300, 3600];
    const leftHeight = $("#LeftHeight");
    const rightHeight = $("#RightHeight");
    const topWidth = $("#TopWidth");
    const bottomWidth = $("#BottomWidth");
    const frameColour = $("#FrameColour");
    const trackType = $("#TrackType");
    const selectedVariant = $("#SelectedVariant");
    const sizeBandNote = $("#SizeBandNote");
    const productPrice = $("#ProductPrice");
    const addButton = $("#AddConfiguredProduct");
    const status = $("#BuilderStatus");
    const estimate = $("#BuilderEstimate");
    const roomLocation = $("#RoomLocation");
    const softCloseRequired = $("#SoftCloseRequired");
    const removalRequired = $("#RemovalRequired");
    const productHandle = builderForm.dataset.productHandle;
    const framePreview = $("#FrameColourPreview");
    const framePreviewImage = $("#FrameColourPreviewImage");
    const framePreviewName = $("#FrameColourPreviewName");
    const framePreviewButtons = $$("[data-frame-preview]", framePreview || document.createElement("div"));
    const productGallery = $("#ProductGallery");
    const productGalleryImage = $("#ProductGalleryImage");
    const productGalleryColour = $("#ProductGalleryColour");

    const money = (cents) => (cents / 100).toLocaleString("en-AU", { style: "currency", currency: "AUD" });
    const value = (input) => Number(input?.value || 0);
    const softClosePrice = () => softCloseRequired?.checked ? 16500 : 0;
    let installationMarginProductPromise;

    function installationMarginProduct() {
      installationMarginProductPromise ||= fetch(`/products/${productHandle}-installation-margin.js`).then((response) => {
        if (!response.ok) throw new Error("Installed supply pricing is not available for this product.");
        return response.json();
      });
      return installationMarginProductPromise;
    }

    async function installationMarginVariant(variant) {
      const product = await installationMarginProduct();
      const adjustment = product.variants.find((item) => item.option1 === variant.option1 && item.option2 === variant.option3);
      if (!adjustment) throw new Error("Installed supply pricing is not configured for this wardrobe size.");
      return adjustment;
    }

    function selectedBand() {
      const maxWidth = Math.max(value(topWidth), value(bottomWidth));
      return widths.find((width) => maxWidth <= width);
    }

    function selectedHeightBand() {
      const maxHeight = Math.max(value(leftHeight), value(rightHeight));
      if (maxHeight <= 2100) return 2100;
      if (maxHeight <= 2400) return 2400;
      return null;
    }

    function findVariant() {
      const band = selectedBand();
      const heightBand = selectedHeightBand();
      if (!band || !heightBand) return null;
      const size = `${heightBand} x ${band} mm`;
      return variants.find((variant) =>
        variant.option1 === size &&
        variant.option2 === frameColour.value &&
        variant.option3 === trackType.value
      );
    }

    function updateFramePreview() {
      if (!framePreview || !framePreviewImage || !frameColour) return;
      const imageUrl = {
        Black: framePreview.dataset.black,
        "Brushed Gold": framePreview.dataset.brushedGold,
        White: framePreview.dataset.white,
        Chrome: framePreview.dataset.chrome
      }[frameColour.value];
      if (imageUrl) framePreviewImage.src = imageUrl;
      framePreviewImage.alt = `Wardrobe doors with ${frameColour.value} frame`;
      const galleryImageUrl = productGallery ? {
        Black: productGallery.dataset.frameBlack,
        "Brushed Gold": productGallery.dataset.frameBrushedGold,
        White: productGallery.dataset.frameWhite,
        Chrome: productGallery.dataset.frameChrome
      }[frameColour.value] : "";
      if (productGalleryImage && galleryImageUrl) {
        productGalleryImage.src = galleryImageUrl;
        productGalleryImage.srcset = "";
        productGalleryImage.sizes = "";
        productGalleryImage.alt = `${frameColour.value} aluminium frame colour on sliding wardrobe doors`;
      }
      if (productGalleryColour) productGalleryColour.textContent = `${frameColour.value} frame colour reference`;
      if (framePreviewName) framePreviewName.textContent = frameColour.value;
      framePreviewButtons.forEach((button) => {
        const isActive = button.dataset.framePreview === frameColour.value;
        button.classList.toggle("active", isActive);
        button.setAttribute("aria-pressed", String(isActive));
      });
    }

    async function updateBuilder() {
      updateFramePreview();
      const band = selectedBand();
      const heightBand = selectedHeightBand();
      const maxWidth = Math.max(value(topWidth), value(bottomWidth));
      status.textContent = "";
      status.classList.remove("success");

      if (!band || maxWidth > 3600 || !heightBand) {
        sizeBandNote.textContent = "This opening needs a custom quote.";
        selectedVariant.value = "";
        addButton.disabled = true;
        estimate.textContent = "";
        status.textContent = "Online checkout supports openings up to 2400 mm high and 3600 mm wide.";
        return;
      }

      const variant = findVariant();
      sizeBandNote.textContent = `Pricing band: ${heightBand} x ${band} mm`;
      if (!variant) {
        selectedVariant.value = "";
        addButton.disabled = true;
        estimate.textContent = "";
        status.textContent = "This option combination is not available yet. Please request a quote.";
        return;
      }

      selectedVariant.value = variant.id;
      productPrice.textContent = money(variant.price);
      addButton.disabled = !variant.available;
      const quantity = Math.max(1, value($("#SetQuantity")));
      const installationRequired = $("#InstallationRequired")?.checked;
      if (removalRequired) {
        removalRequired.disabled = !installationRequired;
        if (!installationRequired) removalRequired.checked = false;
      }
      const installation = installationRequired ? 19900 + 9900 * Math.max(0, quantity - 1) : 0;
      const supplyOnlyHandling = installationRequired ? 0 : 6600;
      const softClose = softClosePrice() * quantity;
      const removal = installationRequired && removalRequired?.checked ? 16500 * quantity : 0;
      let installationAdjustment = 0;
      if (installationRequired) {
        try {
          installationAdjustment = (await installationMarginVariant(variant)).price * quantity;
        } catch (error) {
          addButton.disabled = true;
          estimate.textContent = "";
          status.textContent = error.message;
          return;
        }
      }
      const included = [installation ? "installation" : "supply-only handling", softClose ? "soft close" : "", removal ? "removal and disposal" : ""].filter(Boolean);
      estimate.textContent = `Estimated total: ${money(variant.price * quantity + installationAdjustment + installation + supplyOnlyHandling + softClose + removal)} including ${included.join(", ")}`;
      if (!variant.available) status.textContent = "This combination is currently unavailable.";
    }

    [leftHeight, rightHeight, topWidth, bottomWidth].forEach((input) => input?.addEventListener("input", updateBuilder));
    [frameColour, trackType].forEach((input) => input?.addEventListener("change", updateBuilder));
    framePreviewButtons.forEach((button) => button.addEventListener("click", () => {
      frameColour.value = button.dataset.framePreview;
      frameColour.dispatchEvent(new Event("change", { bubbles: true }));
    }));
    [$("#SetQuantity"), $("#InstallationRequired"), softCloseRequired, removalRequired].forEach((input) => input?.addEventListener("change", updateBuilder));

    function lineProperties() {
      const data = new FormData(builderForm);
      const properties = {};
      for (const [key, entryValue] of data.entries()) {
        const match = key.match(/^properties\\[(.+)\\]$/);
        if (match) properties[match[1]] = entryValue;
      }
      properties["Frame colour"] = frameColour.value;
      properties["Track type"] = trackType.value;
      properties["Pricing size band"] = sizeBandNote.textContent.replace("Pricing band: ", "");
      return properties;
    }

    async function installationItems(quantity) {
      if (!$("#InstallationRequired")?.checked) return [];
      const response = await fetch("/products/wardrobe-door-installation.js");
      if (!response.ok) throw new Error("Installation service product is not available.");
      const installationProduct = await response.json();
      const firstSet = installationProduct.variants.find((variant) => variant.sku === "AUR-WD-INSTALL-FIRST");
      const additionalSet = installationProduct.variants.find((variant) => variant.sku === "AUR-WD-INSTALL-ADDITIONAL");
      if (!firstSet || (quantity > 1 && !additionalSet)) throw new Error("Installation service is not configured.");
      return [
        { id: firstSet.id, quantity: 1, properties: { Service: "Wardrobe installation - first set" } },
        ...(quantity > 1 ? [{ id: additionalSet.id, quantity: quantity - 1, properties: { Service: "Wardrobe installation - additional set" } }] : [])
      ];
    }

    async function softCloseItems(quantity) {
      if (!softCloseRequired?.checked) return [];
      const response = await fetch("/products/wardrobe-door-soft-close.js");
      if (!response.ok) throw new Error("Soft close option is not available.");
      const softCloseProduct = await response.json();
      const variant = softCloseProduct.variants[0];
      if (!variant) throw new Error("Soft close is not configured.");
      return [{ id: variant.id, quantity, properties: { Service: "Wardrobe door soft close", Product: productHandle, Size: `${selectedHeightBand()} x ${selectedBand()} mm` } }];
    }

    async function installationMarginItems(quantity, variant) {
      if (!$("#InstallationRequired")?.checked) return [];
      const adjustment = await installationMarginVariant(variant);
      return [{ id: adjustment.id, quantity, properties: { Service: "Installed wardrobe supply adjustment", Product: productHandle, Size: variant.option1, Track: variant.option3 } }];
    }

    async function removalItems(quantity) {
      if (!$("#InstallationRequired")?.checked || !removalRequired?.checked) return [];
      const response = await fetch("/products/wardrobe-door-removal-disposal.js");
      if (!response.ok) throw new Error("Removal and disposal is not available.");
      const product = await response.json();
      const variant = product.variants[0];
      if (!variant) throw new Error("Removal and disposal is not configured.");
      return [{ id: variant.id, quantity, properties: { Service: "Remove and dispose existing wardrobe doors" } }];
    }

    async function supplyOnlyHandlingItems() {
      if ($("#InstallationRequired")?.checked) return [];
      const [handlingProduct, cart] = await Promise.all([
        fetch("/products/wardrobe-supply-only-handling.js").then((response) => {
          if (!response.ok) throw new Error("Supply-only handling is not configured.");
          return response.json();
        }),
        fetch("/cart.js").then((response) => response.json())
      ]);
      if (cart.items.some((item) => item.handle === "wardrobe-supply-only-handling")) return [];
      const variant = handlingProduct.variants[0];
      if (!variant) throw new Error("Supply-only handling is not configured.");
      return [{ id: variant.id, quantity: 1, properties: { Service: "Wardrobe supply-only handling" } }];
    }

    addButton?.addEventListener("click", async () => {
      const invalidField = Array.from(builderForm.elements).find((field) => field.willValidate && !field.checkValidity());
      if (invalidField) {
        builderForm.reportValidity();
        status.classList.remove("success");
        status.textContent = invalidField === roomLocation
          ? "Enter the room location before adding to cart."
          : "Complete the highlighted required fields before adding to cart.";
        invalidField.focus();
        return;
      }
      updateBuilder();
      if (!selectedVariant.value) return;

      addButton.disabled = true;
      addButton.textContent = "Adding to cart...";
      status.textContent = "";
      try {
        const quantity = Math.max(1, value($("#SetQuantity")));
        const items = [{
          id: Number(selectedVariant.value),
          quantity,
          properties: lineProperties()
        }];
        const configuredVariant = findVariant();
        items.push(...await installationMarginItems(quantity, configuredVariant));
        items.push(...await installationItems(quantity));
        items.push(...await softCloseItems(quantity));
        items.push(...await removalItems(quantity));
        items.push(...await supplyOnlyHandlingItems());
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || "Could not add this configuration.");
        }
        status.textContent = "Configuration added. Opening your cart...";
        status.classList.add("success");
        window.location.href = "/cart";
      } catch (error) {
        status.textContent = error.message;
        addButton.disabled = false;
        addButton.textContent = "Add configured doors to cart";
      }
    });

    const incoming = new URLSearchParams(window.location.search);
    const incomingWidth = Number(incoming.get("width"));
    if (incomingWidth && topWidth && bottomWidth) {
      topWidth.value = incomingWidth;
      bottomWidth.value = incomingWidth;
    }
    if (incoming.get("track") === "slimline" && trackType) {
      trackType.value = "83mm Slimline Triple Track";
    }
    updateBuilder();
  }

  const assistant = $("#AurexAssistant");
  if (assistant) {
    const launcher = $("#AssistantLauncher", assistant);
    const close = $("#AssistantClose", assistant);
    const panel = $("#AssistantPanel", assistant);
    const mascot = $("#AssistantMascot", assistant);
    const mascotCallout = $("#AssistantMascotCallout", assistant);
    const conversation = $("#AssistantConversation", assistant);
    const questionForm = $("#AssistantQuestionForm", assistant);
    const questionInput = $("#AssistantQuestion", assistant);
    const quickActions = $("#AssistantQuickActions", assistant);
    const leadPanel = $("#AssistantLead", assistant);
    const leadForm = $("#AurexAssistantLeadForm", assistant);
    const faqsNode = $("#AurexAssistantFaqs", assistant);
    let faqs = faqsNode ? JSON.parse(faqsNode.textContent) : [];
    if (!faqs.length) {
      faqs = [
        {
          question: "How do I measure?",
          keywords: "measure, measuring, measurements, size, height, width",
          answer: "Measure in millimetres at four points: left height, right height, top width and bottom width. Measure heights from the front floor edge to the top, and widths from left to right."
        },
        {
          question: "What can I order?",
          keywords: "wardrobe, options, finish, frame, colour, track",
          answer: "Aurex offers made-to-measure wardrobe doors with several panel finishes, four frame colours and standard double or slimline triple tracks."
        },
        {
          question: "Do you offer shower screens?",
          keywords: "shower, screen, bathroom",
          answer: "Yes. Aurex can prepare a shower-screen quote based on your opening, glass and hardware requirements."
        }
      ];
    }
    const transcript = [];

    const setAssistant = (isOpen) => {
      assistant.classList.toggle("is-open", isOpen);
      launcher?.setAttribute("aria-expanded", String(isOpen));
      if (isOpen) window.setTimeout(() => questionInput?.focus(), 180);
    };

    const addMessage = (text, sender = "bot", link) => {
      const message = document.createElement("div");
      message.className = `assistant-message assistant-message-${sender}`;
      const paragraph = document.createElement("p");
      paragraph.textContent = text;
      message.appendChild(paragraph);
      if (link?.url && link?.label) {
        const anchor = document.createElement("a");
        anchor.href = link.url;
        anchor.textContent = link.label;
        anchor.className = "assistant-message-link";
        message.appendChild(anchor);
      }
      conversation.appendChild(message);
      conversation.scrollTop = conversation.scrollHeight;
      transcript.push(`${sender === "user" ? "Customer" : "Assistant"}: ${text}`);
    };

    const normalize = (text) => text.toLowerCase().replace(/[^a-z0-9\\s]/g, " ");
    const faqScore = (faq, question) => {
      const cleanQuestion = normalize(question);
      const words = faq.keywords.split(",").map((word) => normalize(word).trim()).filter(Boolean);
      return words.reduce((score, word) => score + (cleanQuestion.includes(word) ? Math.max(1, word.split(" ").length) : 0), 0);
    };

    const bestFaq = (question) => faqs
      .map((faq) => ({ faq, score: faqScore(faq, question) }))
      .sort((a, b) => b.score - a.score)[0];

    const askAI = async (question) => {
      const endpoint = assistant.dataset.aiEndpoint;
      if (!endpoint) return null;
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          question,
          page: window.location.href,
          history: transcript.slice(-8)
        })
      });
      if (!response.ok) throw new Error("Assistant service unavailable");
      const result = await response.json();
      return result.answer;
    };

    const answerQuestion = async (question) => {
      const trimmed = question.trim();
      if (!trimmed) return;
      addMessage(trimmed, "user");
      questionInput.value = "";

      if (/\\b(check\\s*out|checkout|cart|basket|pay now)\\b/i.test(trimmed)) {
        addMessage("Your payment stays securely inside Shopify. Review the configured products in your cart, then continue to checkout.", "bot", {
          label: "View cart and checkout",
          url: "/cart"
        });
        return;
      }

      const match = bestFaq(trimmed);
      if (match?.score > 0) {
        addMessage(match.faq.answer, "bot", {
          label: match.faq.linkLabel,
          url: match.faq.linkUrl
        });
        return;
      }

      const thinking = document.createElement("div");
      thinking.className = "assistant-message assistant-message-bot assistant-thinking";
      thinking.textContent = "Checking that for you...";
      conversation.appendChild(thinking);
      conversation.scrollTop = conversation.scrollHeight;

      try {
        const answer = await askAI(trimmed);
        thinking.remove();
        if (answer) {
          addMessage(answer, "bot");
        } else {
          addMessage("I do not want to guess. Leave your details and Aurex can confirm the right option for your project.", "bot");
          showLead();
        }
      } catch (error) {
        thinking.remove();
        addMessage("I could not confirm that automatically. Send your project details and Aurex will follow it up.", "bot");
        showLead();
      }
    };

    const showLead = () => {
      quickActions.hidden = true;
      questionForm.hidden = true;
      leadPanel.hidden = false;
      leadPanel.querySelector("input:not([type='hidden'])")?.focus();
    };

    const hideLead = () => {
      leadPanel.hidden = true;
      quickActions.hidden = false;
      questionForm.hidden = false;
      questionInput?.focus();
    };

    launcher?.addEventListener("click", () => setAssistant(!assistant.classList.contains("is-open")));
    close?.addEventListener("click", () => setAssistant(false));
    questionForm?.addEventListener("submit", (event) => {
      event.preventDefault();
      answerQuestion(questionInput.value);
    });
    $$("[data-assistant-question]", assistant).forEach((button) => {
      button.addEventListener("click", () => answerQuestion(button.dataset.assistantQuestion));
    });
    $$("[data-assistant-lead]", assistant).forEach((button) => button.addEventListener("click", showLead));
    $$("[data-assistant-back]", assistant).forEach((button) => button.addEventListener("click", hideLead));

    leadForm?.addEventListener("submit", () => {
      const product = $("#AssistantLeadProduct", assistant)?.value || "Not specified";
      const suburb = $("#AssistantLeadSuburb", assistant)?.value || "Not specified";
      const details = $("#AssistantLeadDetails", assistant)?.value || "Not supplied";
      $("#AssistantLeadTranscript", assistant).value = [
        "New lead from the Aurex website assistant",
        "",
        `Product: ${product}`,
        `Suburb: ${suburb}`,
        `Project details: ${details}`,
        "",
        "Conversation:",
        transcript.length ? transcript.join("\\n") : "No questions asked before enquiry."
      ].join("\\n");
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && assistant.classList.contains("is-open")) setAssistant(false);
    });

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const mascotMoves = ["is-dancing", "is-wobbling", "is-bouncing", "is-spinning", "is-peeking"];
    const mascotPrompts = [
      "Psst... need a hand?",
      "I know wardrobe stuff!",
      "Click me. I dare you.",
      "Four measurements. Easy.",
      "Need a quick quote?",
      "Your robe could look fancy.",
      "I can help with showers too!"
    ];
    let lastMascotMove = -1;
    let mascotTimer;

    const performMascotMove = () => {
      if (reducedMotion.matches || assistant.classList.contains("is-open") || document.hidden) {
        scheduleMascotMove();
        return;
      }
      mascotMoves.forEach((move) => mascot?.classList.remove(move));
      let nextMove = Math.floor(Math.random() * mascotMoves.length);
      if (nextMove === lastMascotMove) nextMove = (nextMove + 1) % mascotMoves.length;
      lastMascotMove = nextMove;
      mascot?.classList.add(mascotMoves[nextMove]);
      if (mascotCallout) {
        mascotCallout.textContent = mascotPrompts[Math.floor(Math.random() * mascotPrompts.length)];
        mascotCallout.classList.add("is-visible");
      }
      window.setTimeout(() => {
        mascotMoves.forEach((move) => mascot?.classList.remove(move));
        mascotCallout?.classList.remove("is-visible");
      }, 3200);
      scheduleMascotMove();
    };

    const scheduleMascotMove = () => {
      window.clearTimeout(mascotTimer);
      mascotTimer = window.setTimeout(performMascotMove, 8000 + Math.random() * 9000);
    };

    mascotCallout?.classList.add("is-visible");
    window.setTimeout(() => mascotCallout?.classList.remove("is-visible"), 4200);
    scheduleMascotMove();

    if ($("[data-assistant-lead-success]", assistant) || $(".assistant-form-error", assistant)) {
      setAssistant(true);
      showLead();
    }
  }

})();

/* assets/frame-colour-picker.js */
/* Frame colour image cards removed. The Frame Colour dropdown remains the single colour control. */

/* assets/door-count-preview.js */
(function () {
  var TWO_DOOR_MIRROR = {
    Black: 'https://cdn.shopify.com/s/files/1/0751/7067/6904/files/mirror-two-door-black.png?v=1781179969&width=720',
    White: 'https://cdn.shopify.com/s/files/1/0751/7067/6904/files/mirror-two-door-white.png?v=1781179952&width=720',
    Chrome: 'https://cdn.shopify.com/s/files/1/0751/7067/6904/files/mirror-two-door-chrome.png?v=1781179979&width=720',
    'Mat Natural': 'https://cdn.shopify.com/s/files/1/0751/7067/6904/files/mirror-two-door-mat-natural.png?v=1781179988&width=720',
    Cream: 'https://cdn.shopify.com/s/files/1/0751/7067/6904/files/mirror-two-door-cream.png?v=1781179995&width=720'
  };
  var THREE_DOOR_MIRROR_EXTRA = {
    'Mat Natural': 'https://cdn.shopify.com/s/files/1/0751/7067/6904/files/wardrobe-mirror-mat-natural.png?v=1781172199&width=720',
    Cream: 'https://cdn.shopify.com/s/files/1/0751/7067/6904/files/wardrobe-mirror-cream.png?v=1781172209&width=720'
  };
  function value(input) { return Number(input && input.value || 0); }
  function productIsMirror() { return window.location.pathname.indexOf('/products/mirror-sliding-wardrobe-doors') !== -1; }
  function galleryImage(gallery, colour) {
    if (colour === 'Black') return gallery.dataset.frameBlack;
    if (colour === 'Chrome') return gallery.dataset.frameChrome;
    if (colour === 'Brushed Gold') return gallery.dataset.frameBrushedGold;
    if ((colour === 'Mat Natural' || colour === 'Cream') && productIsMirror()) return THREE_DOOR_MIRROR_EXTRA[colour];
    return gallery.dataset.frameWhite;
  }
  function setImage(image, url, alt) {
    if (!image || !url) return;
    image.src = url; image.srcset = ''; image.sizes = ''; image.alt = alt;
  }
  function initProductGallery() {
    var gallery = document.getElementById('ProductGallery');
    var image = document.getElementById('ProductGalleryImage');
    var label = document.getElementById('ProductGalleryColour');
    var colourSelect = document.getElementById('FrameColour');
    var topWidth = document.getElementById('TopWidth');
    var bottomWidth = document.getElementById('BottomWidth');
    if (!gallery || !image || !colourSelect) return;
    function update() {
      var colour = colourSelect.value;
      var doors = Math.max(value(topWidth), value(bottomWidth)) > 2400 ? 3 : 2;
      var url = productIsMirror() && doors === 2 && TWO_DOOR_MIRROR[colour] ? TWO_DOOR_MIRROR[colour] : galleryImage(gallery, colour);
      setImage(image, url, doors + '-door ' + document.title.split('·')[0].trim() + ' with ' + colour + ' frame');
      gallery.dataset.doorCount = String(doors);
      if (label) label.textContent = doors + '-door layout · ' + colour + ' frame colour reference';
      var property = document.getElementById('DoorLayoutProperty');
      if (!property) {
        property = document.createElement('input'); property.type = 'hidden'; property.id = 'DoorLayoutProperty'; property.name = 'properties[Door layout]';
        document.getElementById('AurexProductForm').appendChild(property);
      }
      property.value = doors + ' doors';
    }
    [topWidth, bottomWidth].forEach(function (input) { if (input) { input.addEventListener('input', update); input.addEventListener('change', update); } });
    colourSelect.addEventListener('change', update);
    update();
  }
  function initHomePreview() {
    var preview = document.getElementById('door-preview');
    if (!preview) return;
    var selectedWidth = 2100;
    var selectedFinish = 'Mirror';
    var finishImages = { Gyprock: preview.dataset.gyprock, Mirror: preview.dataset.mirror, 'White Glass': preview.dataset.whiteGlass, 'Vinyl Back': preview.dataset.vinylBack, 'Semi Frameless': preview.dataset.semiFrameless, 'VJ Primed': preview.dataset.vj };
    var previewReady = false;
    function update() {
      if (!previewReady) return;
      var isTwoDoor = selectedWidth <= 2400;
      var url = selectedFinish === 'Mirror' && isTwoDoor ? TWO_DOOR_MIRROR.White : finishImages[selectedFinish];
      if (url) preview.style.backgroundImage = 'url("' + url + '")';
      preview.setAttribute('aria-label', (isTwoDoor ? '2-door ' : '3-door ') + selectedFinish + ' wardrobe preview');
    }
    function revealPreview() { previewReady = true; update(); }
    document.querySelectorAll('[data-config-group="width"] .choice').forEach(function (button) { button.addEventListener('click', function () { selectedWidth = Number(button.dataset.value); revealPreview(); }); });
    document.querySelectorAll('[data-config-group="finish"] .choice').forEach(function (button) { button.addEventListener('click', function () { selectedFinish = button.dataset.value; revealPreview(); }); });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        revealPreview();
      }, { rootMargin: '400px 0px' });
      observer.observe(preview);
    } else {
      revealPreview();
    }
  }
  function init() { initProductGallery(); initHomePreview(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* assets/wardrobe-page.js */
(function(){
  var root=document.getElementById('WardrobePage');
  if(!root)return;
  var imageNode=document.getElementById('WardrobePageImages');
  if(!imageNode)return;
  var images={};
  try{images=JSON.parse(imageNode.textContent);}catch(error){return;}
  var selectedColour='brushedGold';
  var colourLabels={black:'Black',brushedGold:'Brushed Gold',white:'White',chrome:'Chrome'};
  var productHandles={Mirror:'mirror-sliding-wardrobe-doors','VJ Primed':'vj-primed-sliding-wardrobe-doors','White Glass':'super-white-glass-sliding-wardrobe-doors','Semi Frameless':'semi-frameless-sliding-wardrobe-doors',Gyprock:'gyprock-vinyl-sliding-wardrobe-doors','Vinyl Back':'vinyl-back-sliding-wardrobe-doors'};
  var productCache={};
  var priceRequest=0;
  var width='2100';
  var finish=document.getElementById('WardrobeFinish');
  var frame=document.getElementById('WardrobeFrame');
  var slimline=document.getElementById('WardrobeSlimline');
  var preview=document.getElementById('WardrobeBuilderPreview');
  var price=document.getElementById('WardrobeBuilderPrice');
  var summary=document.getElementById('WardrobeBuilderSummary');
  var link=document.getElementById('WardrobeBuilderLink');
  if(!finish||!frame||!slimline||!preview||!price||!summary||!link)return;
  function colourKey(label){return label==='Brushed Gold'?'brushedGold':label.toLowerCase();}
  function setPressed(selector,active){
    root.querySelectorAll(selector).forEach(function(item){
      var selected=item===active;
      item.classList.toggle('is-active',selected);
      item.setAttribute('aria-pressed',selected?'true':'false');
    });
  }
  function updateCards(){
    root.querySelectorAll('.wardrobe-finish-card').forEach(function(card){
      var cardImage=card.querySelector('img');
      var cardLink=card.querySelector('a');
      var key=selectedColour;
      if(!cardImage||!cardLink||!images[card.dataset.finish])return;
      cardImage.src=cardImage.dataset[key]||images[card.dataset.finish][key];
      cardImage.alt=card.dataset.finish+' sliding wardrobe doors with '+colourLabels[selectedColour]+' frame';
      var url=new URL('/products/'+productHandles[card.dataset.finish],window.location.origin);
      url.searchParams.set('frame',colourLabels[selectedColour]);
      cardLink.href=url.pathname+'?'+url.searchParams.toString();
    });
  }
  async function updateBuilder(){
    var finishValue=finish.value;
    var frameValue=frame.value;
    var key=colourKey(frameValue);
    var option=finish.options[finish.selectedIndex];
    if(!option||!images[finishValue]||!images[finishValue][key])return;
    preview.src=images[finishValue][key];
    preview.alt=finishValue+' wardrobe with '+frameValue+' frame';
    summary.textContent='2100mm high x '+width+'mm wide | '+finishValue+' | '+frameValue;
    var params=new URLSearchParams({width:width,track:slimline.checked?'slimline':'standard',frame:frameValue});
    link.href='/products/'+option.dataset.handle+'?'+params.toString();
    var request=++priceRequest;
    price.textContent='Checking price...';
    try{
      var product=productCache[option.dataset.handle];
      if(!product){
        var response=await fetch('/products/'+option.dataset.handle+'.js');
        if(!response.ok)throw new Error('Product price is unavailable.');
        product=await response.json();
        productCache[option.dataset.handle]=product;
      }
      if(request!==priceRequest)return;
      var size='2100 x '+width+' mm';
      var track=slimline.checked?'83mm Slimline Triple Track':'83mm Standard Double Track';
      var variant=product.variants.find(function(item){return item.option1===size&&item.option2===frameValue&&item.option3===track;});
      if(!variant)throw new Error('Selected price is unavailable.');
      price.textContent=((variant.price+6600)/100).toLocaleString('en-AU',{style:'currency',currency:'AUD'});
    }catch(error){
      if(request===priceRequest)price.textContent='Price available in full builder';
    }
  }
  root.querySelectorAll('[data-wardrobe-colour]').forEach(function(button){
    button.addEventListener('click',function(){
      setPressed('[data-wardrobe-colour]',button);
      selectedColour=button.dataset.wardrobeColour;
      frame.value=colourLabels[selectedColour];
      updateCards();
      updateBuilder();
    });
  });
  root.querySelectorAll('[data-builder-width]').forEach(function(button){
    button.addEventListener('click',function(){
      setPressed('[data-builder-width]',button);
      width=button.dataset.builderWidth;
      updateBuilder();
    });
  });
  finish.addEventListener('change',updateBuilder);
  frame.addEventListener('change',function(){
    selectedColour=colourKey(frame.value);
    setPressed('[data-wardrobe-colour]',root.querySelector('[data-wardrobe-colour="'+selectedColour+'"]'));
    updateCards();
    updateBuilder();
  });
  slimline.addEventListener('change',updateBuilder);
  updateCards();
  updateBuilder();
})();

/* assets/brushed-gold-builder.js */
(function(){
  function init(){
    var select=document.getElementById('FrameColour');
    var gallery=document.getElementById('ProductGallery');
    var image=document.getElementById('ProductGalleryImage');
    var label=document.getElementById('ProductGalleryColour');
    if(!select||!gallery||!image)return;
    function update(){
      var urls={Black:gallery.dataset.frameBlack,'Brushed Gold':gallery.dataset.frameBrushedGold,White:gallery.dataset.frameWhite,Chrome:gallery.dataset.frameChrome};
      var url=urls[select.value];
      if(url){image.src=url;image.srcset='';image.sizes='';image.alt=document.title.split('|')[0].trim()+' with '+select.value+' aluminium frame';}
      if(label)label.textContent=select.value+' frame colour reference';
    }
    var incoming=new URLSearchParams(window.location.search).get('frame');
    if(incoming&&Array.from(select.options).some(function(option){return option.value===incoming;}))select.value=incoming;
    select.addEventListener('change',function(){window.setTimeout(update,0);});
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
